import ContactSection from '../components/ContactSection.jsx';

export default function ContactPage() {
  return <ContactSection titleTag="h1" />;
}
